import { FC } from "react";
import BlogPost from "../models/blogPost";
import { ButtonBase, Link, Stack, Typography, useTheme } from "@mui/material";
import { getPublicBlogPostHeroImageUrl } from "../utils/fileUtils";
import { formatDate } from "../utils/formatUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

type Props = {
	blogPost: BlogPost;
};

const BlogPostFeatured: FC<Props> = ({ blogPost }) => {
	const nav = useNavigate();
	const theme = useTheme();

	const handleClick = () => {
		nav(`/blog/${blogPost.slug}`);
	};

	return (
		<Stack direction="row" spacing={4}>
			<ButtonBase
				sx={{
					width: '50%',
					borderRadius: 2,
					alignItems: 'stretch'
				}}
				onClick={handleClick}
			>
				<Stack
					sx={{
						width: '100%',
						borderRadius: 2,
						backgroundImage: `url(${getPublicBlogPostHeroImageUrl(blogPost)})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat'
					}}
				/>
			</ButtonBase>
			<Stack spacing={3} flex={1} py={2}>
				<Stack>
					{/* Date, author */}
					<Stack direction="row" spacing={2} alignItems="center">
						<Typography variant="caption" color="textSecondary">
							{formatDate(blogPost.publishDate, 'dddd, MMMM D, YYYY')}
						</Typography>
						<FontAwesomeIcon icon="circle" style={{ color: theme.palette.text.secondary, fontSize: '0.4em' }} />
						<Typography variant="caption" color="textSecondary">Tim Kulig</Typography>
					</Stack>
					{/* Title */}
					<Typography variant="h4" color="textPrimary">
						{blogPost.title}
					</Typography>
				</Stack>
				<Typography variant="body1" color="textSecondary">
					{blogPost.abstract}
				</Typography>
				<Link sx={{ textTransform: 'uppercase' }} href={`blog/${blogPost.slug}`}>Read more...</Link>
			</Stack>
		</Stack>
	);
};

export default BlogPostFeatured;
